import React, { useState, useEffect } from 'react';
// react bootstrap
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
// styles
import { Wrapper } from './SearchBar.styles';

const SearchBar = ({ callback, searchParams }) => {
  const [values, setValues] = useState({});
  const [emptyError, setEmptyError] = useState(false);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === 'title') {
      setValues({ ...values, title: value });
    }

    if (name === 'author') {
      setValues({ ...values, author: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setEmptyError(false);

    if (!values.title && !values.author) {
      setEmptyError(true);
      return;
    }

    callback(values.title, values.author);
  };

  // if search params provided set values state
  useEffect(() => {
    if (searchParams) {
      setValues(searchParams);
    }
  }, [searchParams]);

  return (
    <Wrapper>
      {emptyError && (
        <Alert variant={'danger'}>Write somthing to search !</Alert>
      )}
      <Form onSubmit={handleSubmit}>
        <Form.Group className='mb-3' controlId='formGroupSearchTitle'>
          <Form.Control
            type='search'
            placeholder='Title'
            name='title'
            value={values.title || ''}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group className='mb-3' controlId='formGroupSearchAuthor'>
          <Form.Control
            type='search'
            placeholder='Author'
            name='author'
            value={values.author || ''}
            onChange={handleChange}
          />
        </Form.Group>
        <div className='mt-3'>
          <Button size='lg' type='submit'>
            <i class='bi bi-search pe-2'></i> Search
          </Button>
        </div>
      </Form>
    </Wrapper>
  );
};

export default SearchBar;
